export const EN = 'en';
export const ES = 'es';

const languages = [
  { code: EN, label: 'English' }
];

export default languages;
